import React from 'react';
import { Routes, Route } from "react-router-dom";
import './App.css';
import Impressum from './Impressum';
import HomePage from './HomePage';
import Refs from './Refs';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <div>
      <ScrollToTop />
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/grundlagen" element={<Refs />} />
      </Routes>     
    </div>


  );
}

export default App;
